<div 
  class="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 cursor-pointer hover:shadow-xl transition-shadow"
  (click)="onEdit()"
>
  <div class="p-6 space-y-4">
    <h2 class="text-2xl font-bold text-gray-900">
      {{ news().title }}
    </h2>
    
    @if (isLoadingImages()) {
      <div class="flex items-center justify-center py-8">
        <div class="text-sm text-gray-500">Loading images...</div>
      </div>
    } @else if (imagePreviews().length > 0) {
      <div class="overflow-x-auto">
        <div class="flex gap-3 pb-2">
          @for (preview of imagePreviews(); track preview.storagePath) {
            <div class="flex-shrink-0 w-64 h-48 rounded-lg overflow-hidden">
              <img 
                [src]="preview.url"
                [alt]="news().title"
                class="w-full h-full object-cover"
              />
            </div>
          }
        </div>
      </div>
    }
    
    @if (news().summary) {
      <p class="text-gray-700 text-base leading-relaxed">
        {{ news().summary }}
      </p>
    }
    
    <div class="text-gray-600 text-sm leading-relaxed whitespace-pre-wrap">
      {{ news().content }}
    </div>
    
    @if (news().tags.length > 0) {
      <div class="flex flex-wrap gap-2">
        @for (tag of news().tags; track tag) {
          <span class="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
            #{{ tag }}
          </span>
        }
      </div>
    }
    
    <div class="flex items-center justify-between text-xs text-gray-500 pt-4 border-t border-gray-200">
      <span class="flex items-center gap-1">
        <img src="/user.svg" alt="Author" class="w-4 h-4" />
        {{ news().author }}
      </span>
      <span class="flex items-center gap-1">
        <img src="/clock.svg" alt="Published date" class="w-4 h-4" />
        {{ (news().publishedAt || news().createdAt).toDate() | date:'short' }}
      </span>
    </div>
  </div>
</div>
